/**
 * The Dashboard ReceivablesCard's data — MKS-329. One request to
 * `GET /api/invoices/outstanding`, already aggregated by customer, with paid
 * invoices gone and overdue derived from `dueDate` by the same function the
 * `/invoices` badges use.
 *
 * Per Pitfall 7: 5-minute refetch, 60s staleTime.
 */
import { useQuery } from '@tanstack/react-query';
import { getOutstandingInvoices, type OutstandingCustomerRow } from '../services/api/invoices';

export type { OutstandingCustomerRow };

/** MKS-329 — the server-side aggregation. */
export function useOutstandingInvoices(enabled: boolean) {
  return useQuery({
    queryKey: ['dashboard', 'outstanding-invoices'],
    queryFn: getOutstandingInvoices,
    enabled,
    refetchInterval: 5 * 60_000,
    staleTime: 60_000,
  });
}
